const statistic = {
  displayField: 'subhead',
  name: 'Statistic',
  description: '',
  fields: [
    {
      id: 'stat',
      name: 'Stat',
      type: 'Integer',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'statAppend',
      name: 'statAppend',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'statPrepend',
      name: 'statPrepend',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'subhead',
      name: 'subhead',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'statistic',
    version: 6,
    updatedAt: '2023-08-02T20:55:10.557Z'
  }
};
export default statistic;